import { IGraphicSize } from '@gem/models/commonModel';

import { PayloadType } from 'APP/model/message/messageModel.types';
import { ImagePayload } from 'STORE/Messages/Message/Payload/ImagePayload/ImagePayload';
import { VideoPayload } from 'STORE/Messages/Message/Payload/VideoPayload/VideoPayload';

interface IMediaPreviewPresenter {
  isImageLocal: boolean;
  imageUrl: string;
  imageGraphicSize: IGraphicSize;
}

export const useMediaPreviewPresenter = (
  payload: ImagePayload | VideoPayload
): IMediaPreviewPresenter => {
  const presenter: IMediaPreviewPresenter = {
    get isImageLocal(): boolean {
      return !!payload.localPreview;
    },

    get imageUrl(): string {
      if (presenter.isImageLocal) {
        return payload.localPreview;
      }

      return payload.payloadType === PayloadType.Video ? payload.previewUrl : payload.url;
    },

    get imageGraphicSize(): IGraphicSize {
      return {
        width: payload.graphicSize?.width || 0,
        height: payload.graphicSize?.height || 0,
      };
    },
  };

  return presenter;
};
